import { render, staticRenderFns } from "./DialogTestValori.vue?vue&type=template&id=5bbdb35a&"
import script from "./DialogTestValori.vue?vue&type=script&lang=js&"
export * from "./DialogTestValori.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports